import { render, staticRenderFns } from "./batchTable.vue?vue&type=template&id=329fb31c&"
import script from "./batchTable.vue?vue&type=script&lang=js&"
export * from "./batchTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports